module.exports = __webpack_public_path__ + "img/img-1.171207d1.webp";